
export const FormatPhoneNumber = ( number: string ) => {

    if( number ){

        return '(' + number.substring(0, 3) + ') ' + number.substring(3, 6) + '-' + number.substring(6);
    }

    return '';
}

export const ClearFormatPhoneNumber = ( number: string ) => {

    if( number ){
        return number.replace(/[&#,+()$~%.'":*?<>{}-]/g, '').replace(' ', '');
    }

    return '';
}
